export const iconFontAwesomeEditingBandage = (
	<i className="fa-solid fa-bandage"></i>
);
